if (!customElements.get('autumn-sale-catalog')) {
  customElements.define('autumn-sale-catalog', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      this.mount = this.querySelector('.sale-catalog__mount');
      this.status = this.querySelector('[data-catalog-status]');
      this.categories = [...this.querySelectorAll('[data-catalog-category]')];
      this.cache = new Map();
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-catalog-category], a[data-catalog-filter], a[data-catalog-more]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.load(link.href, {append: link.hasAttribute('data-catalog-more'), focus: !link.hasAttribute('data-catalog-category')});
      }, {signal: this.lifecycle.signal});
      window.addEventListener('popstate', () => this.restore(), {signal: this.lifecycle.signal});
      this.restore();
    }
    checkedUrl(value) {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !this.categories.some(link => {
        const base = new URL(link.href).pathname;
        return url.pathname === base || url.pathname.startsWith(base + '/');
      })) throw new Error('Invalid collection');
      return url;
    }
    restore() {
      const state = new URL(location.href).searchParams;
      const category = this.categories.find(link => new URL(link.href).pathname.split('/').pop() === state.get('boden')) || this.categories[0];
      if (!category) return;
      const url = new URL(category.href);
      const look = state.get('optik');
      if (look && /^[a-z0-9-]+$/.test(look)) url.pathname += '/' + look;
      const current = this.mount.querySelector('[data-catalog-results]');
      if (current?.dataset.collectionUrl !== new URL(category.href).pathname || current?.dataset.sortBy !== 'best-selling' || look || this.hasLoaded) this.load(url, {history: false, focus: false});
    }
    async load(value, {append = false, history = true, focus = false} = {}) {
      let url;
      try {
        url = this.checkedUrl(value);
        url.searchParams.set('sort_by', 'best-selling');
      } catch { return; }
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.mount.setAttribute('aria-busy', 'true');
      this.status.replaceChildren();
      try {
        const requestUrl = new URL(url);
        requestUrl.searchParams.set('section_id', 'autumn-sale-grid');
        const key = requestUrl.href;
        let html = this.cache.get(key);
        if (!html) {
          const response = await fetch(requestUrl, {signal: request.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Collection unavailable');
          html = await response.text();
        }
        if (request.signal.aborted) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const results = parsed.querySelector('[data-catalog-results]');
        if (!results?.querySelector('[data-catalog-items]')) throw new Error('Invalid collection response');
        if (this.cache.size >= 8) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(key, html);
        if (append) {
          const items = this.mount.querySelector('[data-catalog-items]');
          items.append(...results.querySelector('[data-catalog-items]').children);
          this.mount.querySelector('[data-catalog-pagination]').replaceChildren(...results.querySelector('[data-catalog-pagination]').childNodes);
        } else {
          this.mount.replaceChildren(results);
          this.categories.forEach(link => {
            if (new URL(link.href).pathname === results.dataset.collectionUrl) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          if (history) {
            const pageUrl = new URL(location.href);
            const parts = url.pathname.split('/').filter(Boolean);
            const collectionIndex = parts.indexOf('collections');
            pageUrl.searchParams.set('boden', parts[collectionIndex + 1]);
            if (parts[collectionIndex + 2]) pageUrl.searchParams.set('optik', parts[collectionIndex + 2]);
            else pageUrl.searchParams.delete('optik');
            window.history.pushState({}, '', pageUrl);
          }
          if (focus) this.mount.querySelector('[data-catalog-heading]').focus({preventScroll: true});
        }
        this.hasLoaded = true;
        this.querySelector('[data-catalog-announcement]').textContent = this.mount.querySelector('.sale-catalog__result-heading').textContent.trim();
      } catch (error) {
        if (error.name !== 'AbortError') {
          const message = document.createElement('span');
          message.textContent = this.dataset.error + ' ';
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'sale-catalog__retry';
          retry.textContent = this.dataset.retry;
          retry.addEventListener('click', () => this.load(url, {append, history, focus}), {once: true});
          this.status.replaceChildren(message, retry);
        }
      } finally {
        if (this.request === request) this.mount.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.request?.abort();
      this.cache?.clear();
    }
  });
}
